<template>
  <v-app>
    <div v-if="this.$auth">
      <NavBarComponentVue></NavBarComponentVue>
    </div>

    <v-main :class="{ 'app-main': this.$auth }">
      <router-view />
    </v-main>

    <ChatDrawer v-if="this.$auth && canUseGuiare" />

    <v-overlay z-index="9999" :value="this.$overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import NavBarComponentVue from '@/components/navbar/NavBarComponent';
import ChatDrawer from '@/components/chat/ChatDrawer.vue';
import { getContrastColor } from '@/utils/global/tema';
import { canUseGuiare } from '@/utils/guiareAccess';
import { hideTawk, showTawk } from '@/utils/tawk';

export default {
  name: 'App',

  components: {
    NavBarComponentVue,
    ChatDrawer
  },

  data: () => ({
  }),

  computed: {
    canUseGuiare() {
      return canUseGuiare();
    },
  },

  watch: {
    // Onde o guIAre está disponível, escondemos o balão do Tawk pra não
    // sobrepor; nas demais telas/usuários, o Tawk fica visível normalmente.
    canUseGuiare: {
      immediate: true,
      handler(disponivel) {
        if (disponivel) {
          hideTawk();
        } else {
          showTawk();
        }
      },
    },
  },

  mounted() {
    const rawColor = localStorage.getItem('COR_SISTEMA');
    const resolvedColor = ![null, undefined, '', false, 0, 'null', 'undefined', 'false', '0'].includes(rawColor) ? rawColor : this.$tema;
    this.$vuetify.theme.themes.light.primary = resolvedColor;

    const rgb = this.hexToRgb(resolvedColor) || '251,220,4';
    document.documentElement.style.setProperty('--color-primary', resolvedColor);
    document.documentElement.style.setProperty('--color-primary-rgb', rgb);
    document.documentElement.style.setProperty('--color-on-primary', this.getContrastColor(resolvedColor));
  },

  methods: {
    getContrastColor,

    hexToRgb(hex) {
      if (!hex || typeof hex !== 'string') return null;
      const normalized = hex.replace('#', '').trim();
      const value = normalized.length === 3
        ? normalized.split('').map((c) => c + c).join('')
        : normalized;
      if (value.length !== 6) return null;
      const r = parseInt(value.substring(0, 2), 16);
      const g = parseInt(value.substring(2, 4), 16);
      const b = parseInt(value.substring(4, 6), 16);
      if ([r, g, b].some((n) => Number.isNaN(n))) return null;
      return `${r},${g},${b}`;
    },
  },
};
</script>
